import darkMode from './modules/dark-mode.js'
// import mobileMenu from './modules/mobile-menu.js'

import accordionMenu from './modules/accordion-menu.js'
import machineTyping from './modules/machine-typing.js'
import fontChange from './modules/font-change.js'
import counter from './modules/counter.js'
import beforeAfter from './modules/before-after.js'

import swiper8 from './modules/slider-8.js'

import Search from './modules/search.js'

import aos from './modules/aos.js'
